



































import {Component, Vue} from "vue-property-decorator";

import { cartService } from '../services/cart-service';
import { apiService } from '../services/api-service';
import {eventService, Event} from '../services/event-service';
import MainButton from '@/components/MainButton.vue';
import AddressForm from '@/components/AddressForm.vue';
import {Order} from "../model";


@Component({
  components: { MainButton, AddressForm }
})
export default class Checkout extends Vue {
  order!:Order;
  hasInvoiceAddress:boolean = false;

  created () {
    this.order = new Order(cartService.getCart());
  }

  onSubmit () {
    eventService.publish(new Event("showSpinner"));
    apiService.createOrder(this.order)
      .then(orderResponse => {
        window.location.href = orderResponse.approve_url;
      })
      .catch(() => eventService.publish(new Event("hideSpinner")));
  }
}
